import { BillingCapabilitiesResponseDto, InvoiceResponseDto, PartnerOrganizationParentInfoResponseDto, PaymentDetailsResponseDto, SubscriptionPlanDetailsSchema, } from '@lucidlink/dto/web-service-api';
import { arrayParserFromDto, parserFromDto } from '#fetcher';
export const createBillingManager = ({ workspaceFetcher, assertIsAdmin, loginToWorkspace, }) => {
    return new BillingManagerImpl(workspaceFetcher, assertIsAdmin, loginToWorkspace);
};
class BillingManagerImpl {
    workspaceFetcher;
    assertIsAdmin;
    loginToWorkspace;
    billingFetcher;
    constructor(workspaceFetcher, assertIsAdmin, loginToWorkspace) {
        this.workspaceFetcher = workspaceFetcher;
        this.assertIsAdmin = assertIsAdmin;
        this.loginToWorkspace = loginToWorkspace;
        this.billingFetcher = this.workspaceFetcher.createSubFetcher({
            path: ['billing'],
        });
    }
    async getInvoices() {
        await this.loginToWorkspace();
        await this.assertIsAdmin();
        return this.billingFetcher.get('/invoices', {
            parser: arrayParserFromDto(InvoiceResponseDto),
        });
    }
    async getPaymentDetails() {
        await this.loginToWorkspace();
        await this.assertIsAdmin();
        return this.billingFetcher.get('/payment', {
            parser: parserFromDto(PaymentDetailsResponseDto),
        });
    }
    async upsertPaymentDetails(params) {
        await this.loginToWorkspace();
        await this.assertIsAdmin();
        await this.billingFetcher.patch('/payment', {
            body: { ...params },
        });
    }
    async getCapabilities(params) {
        await this.loginToWorkspace();
        await this.assertIsAdmin();
        return this.billingFetcher.get('/capabilities', {
            parser: parserFromDto(BillingCapabilitiesResponseDto),
            queryParams: { ...params },
        });
    }
    async getBillingCapabilities() {
        await this.loginToWorkspace();
        await this.assertIsAdmin();
        return this.billingFetcher.get('/capabilities', {
            parser: parserFromDto(BillingCapabilitiesResponseDto),
            queryParams: {
                filespaces: true,
                members: true,
                storage: true,
                subscription: true,
                teamCache: true,
                nativeLayout: true,
            },
        });
    }
    async getMembersCapabilities() {
        await this.loginToWorkspace();
        await this.assertIsAdmin();
        return this.billingFetcher.get('/capabilities', {
            parser: parserFromDto(BillingCapabilitiesResponseDto),
            queryParams: { members: true },
        });
    }
    async getServiceAccountsCapabilities() {
        await this.loginToWorkspace();
        await this.assertIsAdmin();
        return this.billingFetcher.get('/capabilities', {
            parser: parserFromDto(BillingCapabilitiesResponseDto),
            queryParams: { serviceAccounts: true },
        });
    }
    async getAllowedStorageCapabilities() {
        await this.loginToWorkspace();
        await this.assertIsAdmin();
        return this.billingFetcher.get('/capabilities', {
            parser: parserFromDto(BillingCapabilitiesResponseDto),
            queryParams: { allowedStorageTypes: true },
        });
    }
    async getPlans() {
        await this.loginToWorkspace();
        await this.assertIsAdmin();
        return this.billingFetcher.get('/choose-plan', {
            parser: (jsonBody) => SubscriptionPlanDetailsSchema.parse(jsonBody),
        });
    }
    async switchPlan(params) {
        await this.loginToWorkspace();
        await this.assertIsAdmin();
        return this.billingFetcher.put('/plan', {
            body: { ...params },
        });
    }
    async getParentOrganization() {
        await this.loginToWorkspace();
        await this.assertIsAdmin();
        return this.workspaceFetcher.get('/parent-organization', {
            parser: parserFromDto(PartnerOrganizationParentInfoResponseDto),
        });
    }
}
